import { BranchPickerPrimitive } from '@assistant-ui/react';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import cx from 'clsx';

import { TooltipIconButton } from '../tooltip-icon-button/TooltipIconButton.tsx';
import classes from './BranchPicker.module.css';

/** Allows navigation between conversation branches when multiple AI response alternatives exist at the same point in the thread. */
export function BranchPicker({ className, ...rest }: BranchPickerPrimitive.Root.Props) {
  return (
    // hideWhenSingleBranch prevents UI clutter when there's no alternative response to navigate to
    <BranchPickerPrimitive.Root className={cx(classes.branchPicker, className)} hideWhenSingleBranch {...rest}>
      <BranchPickerPrimitive.Previous asChild>
        <TooltipIconButton tooltip="Previous">
          <IconChevronLeft />
        </TooltipIconButton>
      </BranchPickerPrimitive.Previous>
      <span>
        <BranchPickerPrimitive.Number /> / <BranchPickerPrimitive.Count />
      </span>
      <BranchPickerPrimitive.Next asChild>
        <TooltipIconButton tooltip="Next">
          <IconChevronRight />
        </TooltipIconButton>
      </BranchPickerPrimitive.Next>
    </BranchPickerPrimitive.Root>
  );
}
